import { __awaiter } from "tslib";
import { DraftCopyService } from "@/services/models/teleOpi/draftCopy";
const moduleTableTicDraftCopy = {
    namespaced: true,
    state: {
        draftsCopies: [],
        userId: 0,
        showLoader: false,
    },
    getters: {
        getShowLoader(state) {
            return state.showLoader;
        },
        getDraftCopies(state) {
            return state.draftsCopies;
        },
    },
    mutations: {
        setLoader(state, payLoad) {
            state.showLoader = payLoad;
        },
        setDataFilter(state, payLoad) {
            state.userId = payLoad;
        },
        setDraftCopies(state, draftsCopies) {
            state.draftsCopies = draftsCopies;
        },
    },
    actions: {
        getDraftCopies({ commit, state }) {
            return __awaiter(this, void 0, void 0, function* () {
                commit("setLoader", true);
                const RESPONSE = yield DraftCopyService.getDraftCopyFindByPatientUser(state.userId);
                commit("setDraftCopies", RESPONSE);
                commit("setLoader", false);
            });
        },
    },
};
export default moduleTableTicDraftCopy;
